import { useDispatch, useSelector } from 'react-redux'

import { useEffect, useRef, useState } from 'react'
import { policeReportsDetailsApi } from '../../../../../lib/fetchApi'
import { formatPatientName } from '../../../../../lib/patientName'
import { notificationActions } from '../../../../../store/notifications'
import { caseActions } from '../../../../../store/case'
import PoliceReportDetailsInner from './PoliceReportDetailsInner'
import MockLoadingBlock from '../../../../mock/MockLoadingBlock'
import { useParams } from 'react-router-dom'
import { socket } from '../../../../../socket'

// {patientId}
export default function PoliceReportDetails() {
    const dispatch = useDispatch()

    const {patientId} = useParams()

    const activeCase = useSelector(state => state.case.activeCase)
    const userToken = useSelector(state => state.user.token)

    const activeCaseMatchesRoute = Boolean(
        activeCase &&
        patientId &&
        patientId !== 'undefined' &&
        patientId !== 'null' &&
        (
            String(activeCase.patient?.person_number) === String(patientId) ||
            String(activeCase.case?.id) === String(patientId)
        )
    )

    const [loading, setLoading] = useState(() => !activeCaseMatchesRoute)
    const [caseFound, setCaseFound] = useState(() => (activeCaseMatchesRoute ? activeCase : null))
    const loadedPatientIdRef = useRef(activeCaseMatchesRoute ? patientId : null)

    const caseId = caseFound?.case?.id

    useEffect(() => {
        if (!userToken || !patientId || patientId === 'undefined' || patientId === 'null') {
            return
        }

        if (loadedPatientIdRef.current === patientId) {
            return
        }

        let cancelled = false

        const getCase = async () => {
            setLoading(true)
            const caseDetail = await policeReportsDetailsApi(userToken, patientId)

            if (cancelled) {
                return
            }

            if (caseDetail.status) {
                dispatch(notificationActions.setError(caseDetail))
            } else {
                dispatch(caseActions.setActiveCase(caseDetail))
                dispatch(caseActions.pushLastActiveCases({
                    id: caseDetail.case.id,
                    name: formatPatientName(caseDetail.patient),
                    person_number: caseDetail.patient.person_number,
                }))

                loadedPatientIdRef.current = patientId
                setCaseFound(caseDetail)
            }
            setLoading(false)
        }

        getCase()

        return () => {
            cancelled = true
        }
    }, [patientId, userToken, dispatch])

    useEffect(() => {
        if (loadedPatientIdRef.current && loadedPatientIdRef.current !== patientId) {
            loadedPatientIdRef.current = null
            setCaseFound(activeCaseMatchesRoute ? activeCase : null)
            setLoading(!activeCaseMatchesRoute)
        }
    }, [patientId, activeCase, activeCaseMatchesRoute])

    useEffect(() => {
        if (!caseId) {
            return
        }

        const eventName = `case-updated-${caseId}`
        const caseUpdatedHandler = (payload) => {
            const incomingData = payload?.data ?? payload?.row ?? payload
            if (!incomingData || typeof incomingData !== 'object') {
                return
            }

            setCaseFound((prevCase) => {
                if (!prevCase) {
                    return prevCase
                }

                const updatedCase = {
                    ...prevCase,
                    ...incomingData,
                    case: {
                        ...prevCase.case,
                        ...incomingData.case,
                        id: prevCase.case?.id,
                    },
                }

                dispatch(caseActions.setActiveCase(updatedCase))
                return updatedCase
            })
        }

        if (!socket.connected) {
            socket.connect()
        }

        socket.on(eventName, caseUpdatedHandler)

        return () => {
            socket.off(eventName, caseUpdatedHandler)
        }
    }, [caseId, dispatch])


    return <>
        {loading && <MockLoadingBlock height={700} width={'100%'} noMargin={true}/>}
        {!loading && caseFound && <PoliceReportDetailsInner />}
    </>
}